
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_2qdw9_1bpgx_99",
  "refresh": "awsui_refresh_2qdw9_1bpgx_138",
  "root-no-actions": "awsui_root-no-actions_2qdw9_1bpgx_138",
  "root-variant-h2": "awsui_root-variant-h2_2qdw9_1bpgx_141",
  "root-variant-h3": "awsui_root-variant-h3_2qdw9_1bpgx_141",
  "root-has-description": "awsui_root-has-description_2qdw9_1bpgx_141",
  "root-variant-h1": "awsui_root-variant-h1_2qdw9_1bpgx_150",
  "main": "awsui_main_2qdw9_1bpgx_160",
  "no-wrap": "awsui_no-wrap_2qdw9_1bpgx_170",
  "main-variant-h1": "awsui_main-variant-h1_2qdw9_1bpgx_176",
  "actions": "awsui_actions_2qdw9_1bpgx_184",
  "actions-centered": "awsui_actions-centered_2qdw9_1bpgx_189",
  "actions-variant-h1": "awsui_actions-variant-h1_2qdw9_1bpgx_192",
  "actions-variant-h2": "awsui_actions-variant-h2_2qdw9_1bpgx_196",
  "actions-variant-h3": "awsui_actions-variant-h3_2qdw9_1bpgx_200",
  "title": "awsui_title_2qdw9_1bpgx_216",
  "title-variant-h1": "awsui_title-variant-h1_2qdw9_1bpgx_221",
  "title-variant-h2": "awsui_title-variant-h2_2qdw9_1bpgx_228",
  "title-variant-h3": "awsui_title-variant-h3_2qdw9_1bpgx_234",
  "virtual-space": "awsui_virtual-space_2qdw9_1bpgx_259",
  "info": "awsui_info_2qdw9_1bpgx_265",
  "description": "awsui_description_2qdw9_1bpgx_269",
  "description-variant-h1": "awsui_description-variant-h1_2qdw9_1bpgx_276",
  "description-variant-h2": "awsui_description-variant-h2_2qdw9_1bpgx_280",
  "description-variant-h3": "awsui_description-variant-h3_2qdw9_1bpgx_287",
  "heading": "awsui_heading_2qdw9_1bpgx_296",
  "heading-variant-h1": "awsui_heading-variant-h1_2qdw9_1bpgx_307",
  "heading-variant-h2": "awsui_heading-variant-h2_2qdw9_1bpgx_312",
  "heading-variant-h3": "awsui_heading-variant-h3_2qdw9_1bpgx_317",
  "heading-text": "awsui_heading-text_2qdw9_1bpgx_327",
  "heading-text-variant-h1": "awsui_heading-text-variant-h1_2qdw9_1bpgx_330",
  "heading-text-variant-h2": "awsui_heading-text-variant-h2_2qdw9_1bpgx_338",
  "heading-text-variant-h3": "awsui_heading-text-variant-h3_2qdw9_1bpgx_346",
  "counter": "awsui_counter_2qdw9_1bpgx_355"
};
  